"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrofrontendRouter = void 0;
var microfrontendRouter_1 = require("./microfrontendRouter");
Object.defineProperty(exports, "MicrofrontendRouter", { enumerable: true, get: function () { return microfrontendRouter_1.MicrofrontendRouter; } });
//# sourceMappingURL=index.js.map